<template>
  <v-container grid-list-md text-xs-center class="ma-0 pa-0">
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex xs9 class="ma-0 pa-0">
        <v-card color="primary">
          <v-card-text class="px-0">12</v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs3 class="item ma-0 pa-0">
        <v-card color="primary" class="item">
          <blocks />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Blocks from '@/components/Blocks.vue'
  export default {
    name: 'drag-drop',
    components: {
      'blocks': Blocks
    }
  }
</script>
<style scoped>
  .resultContainer {
    height: 350px;
  }

  .item {
    min-height: 500px;
    min-width: 80px;
  }
</style>
